import { useApiClient } from "@/composables/useApiClient";
import { useQuery, useQueryClient } from "@tanstack/vue-query";

export const useApprovedUsers = (
  international: ComputedRef<string | undefined>
) => {
  const queryClient = useQueryClient();
  const { toolsUsers: toolsUsersService } = useApiClient();

  const { data: approvedUsers, refetch: refetchApprovedUsers } = useQuery(
    {
      queryKey: ["approvedUsers", international],
      queryFn: async () =>
        await toolsUsersService.listApprovedToolsUsers({
          international: international.value,
        }),
    },
    queryClient
  );

  watch(international, () => refetchApprovedUsers);

  return {
    approvedUsers,
  };
};
